import _includes from "lodash/includes";
import _merge from "lodash/merge";
import * as keyboardKey from 'keyboard-key';
import popupBehavior from '../Popup/popupBehavior';
/**
 * @description
 * Implements ARIA [MenuButton](https://www.w3.org/TR/wai-aria-practices/#menubutton) design pattern.
 *
 * @specification
 * Adds role='none'.
 * Adds attribute 'aria-haspopup=true' to 'trigger' slot if 'contextMenu' property is not set.
 * Adds attribute 'tabIndex=-1' based on the property 'open' to 'trigger' slot.
 * Adds attribute 'aria-controls=menu-id' based on the property 'menuId' to 'trigger' slot.
 * Adds attribute 'aria-expanded=true' based on the property 'open' to 'trigger' slot.
 * Adds attribute 'id=trigger-id' based on the property 'triggerId' to 'trigger' slot.
 * Adds attribute 'id=menu-id' based on the property 'menuId' to 'menu' slot.
 * Adds attribute 'aria-labelledby=trigger-id' based on the property 'triggerId' to 'menu' slot.
 */

var menuButtonBehavior = function menuButtonBehavior(props) {
  var behavior = popupBehavior(props);
  return _merge(behavior, {
    attributes: {
      root: {
        role: 'none'
      },
      trigger: Object.assign({
        'aria-controls': props.menuId,
        'aria-expanded': props.open || undefined,
        'aria-haspopup': props.contextMenu ? undefined : 'true',
        id: props.triggerId
      }, !props.contextMenu && props.open && {
        tabIndex: -1
      }),
      menu: {
        'aria-labelledby': props.triggerId,
        id: props.menuId
      }
    },
    keyActions: {
      root: Object.assign({}, props.open ? {
        closeMenu: {
          keyCombinations: [{
            keyCode: keyboardKey.Tab,
            shiftKey: false
          }, {
            keyCode: keyboardKey.Tab,
            shiftKey: true
          }]
        }
      } : _includes(props.on, 'click') && {
        openAndFocusFirst: {
          keyCombinations: [{
            keyCode: keyboardKey.ArrowDown
          }]
        },
        openAndFocusLast: {
          keyCombinations: [{
            keyCode: keyboardKey.ArrowUp
          }]
        }
      })
    }
  });
};

export default menuButtonBehavior;